import { observeAttributes } from '@edicom/common/observer/observeAttributes';

import { load } from './load';
import { updateDensity } from './density';
import { DIRECTIVE_SKIN, DIRECTIVE_DENSITY, WATCH_DIRECTIVE, ID_SKIN } from './constants';

/**
 * init from directives:
 * - edicom-theme-theme
 * - edicom-theme-density
 * - edicom-theme-watch
 */

export function initDirectives() {
  const isWatch = document.documentElement.hasAttribute(WATCH_DIRECTIVE);

  if (document.documentElement.hasAttribute(DIRECTIVE_SKIN) || document.documentElement.hasAttribute(DIRECTIVE_DENSITY)) {
    // cargamos el skin desde la directiva edicom-theme-skin
    const skinUrl = document.documentElement.getAttribute(DIRECTIVE_SKIN);
    skinUrl &&
      load(skinUrl, ID_SKIN)
        .then(() => {
          dispatchThemeLoaded(skinUrl);
        })
        .catch(() => {}); // error silencioso

    // cargamos el density desde la directiva edicom-theme-density
    updateDensity();

    // si esta declarada el atributo edicom-theme-watch, escuchamos cambios:

    if (isWatch) {
      /**
       * init watcher
       */
      observeAttributes(document.documentElement, (name, newValue, oldValue) => {
        if (newValue === oldValue) {
          return;
        }

        switch (name) {
          case DIRECTIVE_SKIN:
            load(newValue, ID_SKIN).then(() => {
              dispatchThemeLoaded(newValue);
            });
            break;

          case DIRECTIVE_DENSITY:
            updateDensity();
            break;

          default:
            break;
        }
      });
    }
  }
}

/**
 *
 * @example document.addEventListener('theme:loaded', ev => { console.log('ev', ev); });
 *
 *
 * @param {string} url
 */
function dispatchThemeLoaded(url) {
  document.documentElement.setAttribute('edicom-theme-loaded', 'true');

  document.dispatchEvent(
    new CustomEvent('theme:loaded', {
      detail: {
        url,
      },
      bubbles: true,
      composed: true, // necesario para cuando target !== this
    })
  );
}
